import React from 'react';
import { VerticalSteppedProcess } from './VerticalSteppedProcess';
const SteppedProcessBase = ({ steps, variant, a11y }) => {
    return variant === 'vertical' ? (React.createElement(VerticalSteppedProcess, { variant: "vertical", steps: steps, a11y: a11y })) : null;
};
export { SteppedProcessBase };
//# sourceMappingURL=SteppedProcessBase.js.map